import * as React from 'react';

import { PropertyAmenityDescription, PropertyDetailedAmenities } from '@shared-ui/lodging-property-details';
import { RefTarget } from '@shared-ui/ref-context';

import { UitkSpacing } from 'uitk-react-spacing';

import { SharedUiWrapperProps, withSharedUiPropertyDetails } from './shared-ui-property-details';
import { SimpleLazyLoadWrapper } from 'components/common/lazy/simple-lazy-load-wrapper';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';

const AmenityDescriptionWrapper: React.FC<SharedUiWrapperProps> = ({ inputs }) => (
  <UitkSpacing margin={{ block: 'six' }}>
    <RefTarget name="Amenities">
      <SimpleLazyLoadWrapper>
        <Experiment name="Detailed_Content_Amenities">
          <ExperimentControl>
            <PropertyAmenityDescription inputs={inputs} />
          </ExperimentControl>
          <ExperimentVariant bucket={1}>
            <PropertyDetailedAmenities inputs={inputs} />
          </ExperimentVariant>
        </Experiment>
      </SimpleLazyLoadWrapper>
    </RefTarget>
  </UitkSpacing>
);

export const SharedUiAmenityDescriptionWrapper = withSharedUiPropertyDetails(AmenityDescriptionWrapper);
SharedUiAmenityDescriptionWrapper.displayName = 'SharedUiAmenityDescriptionWrapper';
